import v1 from 'src/effector/products/v1';
import v2 from 'src/effector/products/v2';

const func = window.productsResultNewUi ? v2 : v1;
export const { actions, store, stores } = func();
